/** Đếm số bản ghi đang THAM CHIẾU một ví — ví còn được tham chiếu thì chỉ cho "ngừng dùng", không cho xoá. */
type Rows = Record<string, any[]>;
export const walletRefCount = (id: string, d: Rows, debtPayments: any[] = []): number => {
  const c = (rows: any[] | undefined, pred: (r: any) => boolean) => (rows ?? []).filter(pred).length;
  return (
    c(d.incomes, r => (r.walletId ?? r.sourceId) === id) +
    c(d.expenses, r => (r.walletId ?? r.sourceId) === id) +
    c(d.transfers, r => r.fromSourceId === id || r.toSourceId === id) +
    c(d.creditPayments, r => r.creditCardId === id || r.sourceWalletId === id) +
    c(d.plannedExpenses, r => r.walletId === id) +
    c(d.plannedIncomes, r => r.walletId === id) +
    c(d.plannedPayments, r => r.sourceWalletId === id || r.creditCardId === id) +
    c(d.recurringTemplates, r => r.walletId === id) +
    c(d.debts, r => r.sourceAccountId === id || r.creditCardId === id) +
    c(debtPayments, r => r.sourceId === id)
  );
};
